export const APP_CONSTANTS = {
  member: {
    types: {
      UNKNOWN: 0,
      INDIVIDUAL_MEMBER: 1,
      BUSINESS_MEMBER: 2,
      COLLATERAL_MANAGER_MEMBER: 3,
    },
    profileStatuses: {
      PENDING_SUBMIT: -1,
      PENDING_VERIFY: 0,
      UPDATED_FROM_BANK: 1,
      APPROVED: 2,
      BINKABI_APPROVED: 3,
    },
    warehouseStatuses: {
      PENDING: 0,
      APPROVED: 1,
      SUBMITTED_TO_WARE_HOUSE: 2,
      REJECTED: 3,
    },
    bankStatuses: {
      PENDING: 0,
      APPROVED: 1,
    },
    walletStatuses: {
      INACTIVE: 0,
      ACTIVE: 1,
    },
    accountStatuses: {
      INACTIVE: 0,
      ACTIVE: 1,
    },
    accountTypes: {
      PERSONAL: 1,
      BUSINESS: 2,
    },
  },
  adminAction: {
    types: {
      UPLOAD_APPROVE_PHOTO_ID_PROOF: 'UPLOAD_APPROVE_PHOTO_ID_PROOF',
      PROFILE_INFO_VERIFY_CHECKED: 'PROFILE_INFO_VERIFY_CHECKED',
      PROFILE_INFO_VERIFY_UNCHECKED: 'PROFILE_INFO_VERIFY_UNCHECKED',
      PHOTO_ID_VERIFY_CHECKED: 'PHOTO_ID_VERIFY_CHECKED',
      PHOTO_ID_VERIFY_UNCHECKED: 'PHOTO_ID_VERIFY_UNCHECKED',
      NOTE_MEMBER: 'NOTE_MEMBER',
      APPROVE_MEMBER: 'APPROVE_MEMBER',
      ADD_NEW_ADMIN: 'ADD_NEW_ADMIN',
      REMOVE_ADMIN: 'REMOVE_ADMIN',
      EDIT_ADMIN: 'EDIT_ADMIN',
      SEND_MAIL: 'SEND_MAIL',
      SUSPEND_USER: 'SUSPEND_USER',
      ACTIVE_USER: 'ACTIVE_USER',
      CORPORATE_ACCOUNT_SIGNATORY_INFO: 'CORPORATE_ACCOUNT_SIGNATORY_INFO',
    },
    fileAttaches: {
      approvePhotoIdProof: 'approvePhotoIdProof',
      approveSecondPhotoIdProof: 'approveSecondPhotoIdProof',
    },
  },
  roles: {
    ADMIN: 'Admin',
    LENDER_SUPER_ADMIN: 'Lender Super Admin',
    LENDER_ADMIN: 'Lender Admin',
    WAREHOUSE_SUPER_ADMIN: 'Warehouse Super Admin',
    WAREHOUSE_ADMIN: 'Warehouse Admin',
    BANK_SUPER_ADMIN: 'Bank Super Admin',
    BANK_ADMIN: 'Bank Admin',
    MARKET_OPERATOR_SUPER_ADMIN: 'Market Operator Super Admin',
    MARKET_OPERATOR_ADMIN: 'Market Operator Admin',
    INPUT_SUPPLIER: 'Input Supplier',
    EXTENSION_AGENT: 'Extension Agent',
    COLLATERAL_MANAGER_SUPER_ADMIN: 'Collateral Manager Super Admin',
    COLLATERAL_MANAGER_ADMIN: 'Collateral Manager Admin',
    COLLATERAL_SUPER_LENDER: 'Collateral Super Lender',
    COLLATERAL_LENDER: 'Collateral Lender',
    COMMODITY_EXCHANGE_ADMIN: 'Commodity Exchange Admin',
    COMMODITY_EXCHANGE_SUPER_ADMIN: 'Commodity Exchange Super Admin',
    LENDING_APPROVER: 'Lending Approver',
  },
  transaction: {
    types: {
      TRADING: 1,
      TOPUP_FIAT: 2,
      WITHDRAW_FIAT: 3,
      TOPUP_COMMODITY: 4,
      WITHDRAW_COMMODITY: 5,
      SELLER_FEE_OF_TRADING: 6,
      BUYER_FEE_OF_TRADING: 7,
      TRADE_EXPIRED_RELEASE_TOKEN_FOR_SELLER: 8,
      TRADE_EXPIRED_RELEASE_TOKEN_FOR_BUYER: 9,
      FEE_OF_TOPUP_FIAT: 10,
      FEE_OF_WITHDRAW_FIAT: 11,
      FEE_OF_TOPUP_COMMODITY: 12,
      FEE_OF_WITHDRAW_COMMODITY: 13,
      TOPUP_EXPIRED_RELEASE_TOKEN: 14,
      WITHDRAW_EXPIRED_RELEASE_TOKEN: 15,
      DEBTOR_PAYING_FEE: 16,
      CREDITOR_PAYING_FEE: 17,
      DEBTOR_DEPOSITING_COLLATERAL: 18,
      CREDITOR_RECEIVING_COLLATERAL: 19,
      CREDITOR_LENDING_PRINCIPAL: 20,
      DEBTOR_RECEIVING_PRINCIPAL: 21,
      DEBTOR_REPAYING_PRINCIPAL: 22,
      CREDITOR_RECEIVING_PRINCIPAL: 23,
      CREDITOR_RETURNING_COLLATERAL: 24,
      DEBTOR_RECEIVING_COLLATERAL: 25,
      TRANSFER: 26,
      CREATE_FUND: 27,
      CLAIM_FUND: 28,
      LOAN_RELAYER_RECEIVING_FEE_FROM_DEBTOR: 29,
      LOAN_RELAYER_RECEIVING_FEE_FROM_CREDITOR: 30,
      LOAN_RELAYER_RECEIVING_CLT_FEE_FROM_BUYER: 31,
      LOAN_RELAYER_RECEIVING_CLT_FEE_FROM_SELLER: 32,
      LOAN_BUYER_PAYING_CLT_FEE: 33,
      LOAN_SELLER_PAYING_CLT_FEE: 34,
      LOAN_BUYER_PAYING_CLT: 35,
      LOAN_CREDITOR_RECEIVING_CLT_PAYMENT: 36,
      LOAN_DEBTOR_RECEIVING_CLT_PAYMENT: 37,
      LOAN_DEBTOR_SENDING_COLLATERAL_TO_BUYER: 38,
      LOAN_BUYER_RECEIVING_COLLATERAL: 39,
      LOAN_DEBTOR_SENDING_COLLATERAL_TO_CONTRACT: 40,
      LOAN_CONTRACT_RECEIVING_COLLATERAL_FROM_DEBTOR: 41,
      LOAN_CONTRACT_SENDING_COLLATERAL_TO_DEBTOR: 42,
      LOAN_DEBTOR_RECEIVING_COLLATERAL_FROM_CONTRACT: 43,
      LOAN_CONTRACT_SENDING_COLLATERAL_TO_BUYER: 44,
      LOAN_BUYER_RECEIVING_COLLATERAL_FROM_CONTRACT: 45,
    },
    statuses: {
      PENDING: 0,
      SUCCESS: 1,
      FAIL: -1,
      RELEASE_EXPIRED: -2,
      FUND_AVAILABLE: 2,
      FUND_CLAIMED: 3,
    },
    bbRefTypes: {
      TRADE: 1,
      LOAN: 2,
    },
  },
  token: {
    issuers: {
      STER: 'STER',
      UNIB: 'UNIB',
      ACX: 'ACX',
      AFEX: 'AFEX',
    },
    symbols: {
      NGN: 'NGN',
      MAIZE: 'MAIZE',
      RICE: 'RICE',
      SOY: 'SOY',
      CASHEW: 'CASHEW',
      GINGER: 'GINGER',
      FERTILISER_NPK: 'FERTILISER_NPK',
    },
  },
  responseError: {
    actions: {
      MESSAGE_ERROR: 'MessageError',
    },
    codes: {
      ACCOUNT_INACTIVE: 'AccountInactive',
    },
  },
  colors: {
    yellow: '#f7c331',
    blue: '#17a7e7',
    green: '#2ed06e',
    red: '#ff3a22',
    dark_blue: '#213e79',
  },
  warehouseLocation: {
    status: {
      PENDING_VERIFY: 0,
      VERIFIED: 1,
    },
    ownerTypes: {
      WAREHOUSE_PROVIDER: 'WAREHOUSE_PROVIDER',
      COLLATERAL_MANAGER: 'COLLATERAL_MANAGER',
    },
    types: {
      WAREHOUSE: 'WAREHOUSE',
      SILO: 'SILO',
      TANK: 'TANK',
    },
    ownerships: {
      OWNED: 'OWNED',
      THIRD_PARTY: 'THIRD_PARTY',
    },
    storageServices: {
      NOT_PROVIDE: 0,
      PROVIDE: 1,
    },
    providers: {
      AFEX: 1,
      ACX: 2,
    },
  },
  commodity: {
    ownerTypes: {
      WAREHOUSE_PROVIDER: 'WAREHOUSE_PROVIDER',
      COLLATERAL_MANAGER: 'COLLATERAL_MANAGER',
    },
    types: {
      WAREHOUSE_RECEIPT: 'WAREHOUSE_RECEIPT',
      CMA: 'CMA',
    },
  },
  collateralProject: {
    fileAttaches: {
      collateralProjectFile: 'collateralProjectFile',
    },
    statuses: {
      DRAFT: 'DRAFT',
      PUBLISHED: 'PUBLISHED',
      SUSPEND: 'SUSPEND',
      CLOSE: 'CLOSE',
      DELETED: 'DELETED',
    },
    type: {
      COLLATERAL_PROJECT: 1,
      SUPPLY_CHAIN_PROGRAM: 2,
      INPUTS_LENDING_PROGRAM: 3,
    },
  },
  inventoryBalance: {
    types: {
      INVENTORY: 'INVENTORY',
      COLLATERAL: 'COLLATERAL',
    },
  },
  collateralMovement: {
    fileAttaches: {
      collateralMovementFile: 'collateralMovementFile',
    },
    types: {
      DEPOSIT: 1,
      WITHDRAW: 2,
      SELL: 3,
      SELL_BY_CREDITOR: 4,
      PAYMENT_DELIVERY: 5,
      BUY: 6,
    },
    statuses: {
      PENDING_INITIATE: 0,
      INITIATED: 1,
      PENDING_APPROVE: 2,
      APPROVED: 3,
      EXECUTING: 4,
      PENDING_EXECUTE: 5,
      EXECUTED: 6,
      CANCELED: 7,
    },
    exportTypes: {
      GRN: 1,
      WR: 2,
    },
  },
  collateralManager: {
    insurances: {
      FIDELITY: 'FIDELITY',
      PROFESSIONAL_INDEMNITY: 'PROFESSIONAL_INDEMNITY',
    },
    statuses: {
      PENDING_VERIFY: 0,
      APPROVED: 1,
    },
  },
  collateralPermission: {
    INITIAL: 'INITIAL',
    APPROVE: 'APPROVE',
    EXECUTE: 'EXECUTE',
    VIEW: 'VIEW',
  },
  collateralRoleToPermission: {
    trader: 'INITIAL',
    executor: 'EXECUTE',
    viewer: 'VIEW',
    lender: 'APPROVE',
  },
  collateralOnboarding: {
    SUPPLIER: 1,
    BUYER: 2,
  },
  paymentMethods: {
    BY_BINKABI_WALLET: 0,
    BY_CASH: 1,
    BY_BANK_TRANSFER: 2,
    BY_CARD: 3,
  },
  invoice: {
    statuses: {
      DRAFT: 0,
      SUBMITTED: 1,
      ACCEPTED: 2,
      PAID: 3,
      FINANCED: 4,
      CANCELED: 5,
      PENDING_APPROVE: 6,
    },
    createdFrom: {
      MANUALLY: 1,
      SELL_INVENTORY: 2,
      SELL_COLLATERAL: 3,
      SELL_COLLATERAL_BY_LENDER: 4,
      SELL_GOODS_IN_PURCHASE_ORDER: 5,
      SELL_INVENTORY_IN_MARKETPLACE: 6,
      SELL_COLLATERAL_IN_MARKETPLACE: 7,
      SELL_COLLATERAL_BY_LENDER_IN_MARKETPLACE: 8,
      PAYMENT_DELIVERY_TRADE: 9,
      INVOICE_FOR_SUBSCRIBER: 10,
      ORIGINATOR_TO_ISSUER: 11,
      EXTERNAL: 12,
      ORIGINATOR_SELLS_ASSETS: 13,
      DIRECT_ALLOCATION: 14,
    },
  },
  purchase_order: {
    statuses: {
      AUTO_DRAFT: -1,
      DRAFT: 0,
      ACCEPTED: 1,
      FINANCED: 2,
      INVOICED: 3,
      CANCELED: 4,
    },
    createdFrom: {
      MANNUALLY: 1,
      SELL_INVENTORY: 2,
      SELL_COLLATERAL: 3,
      SELL_COLLATERAL_BY_LENDER: 4,
    },
  },
  item: {
    units: {
      NA: 0,
      BAG: 1,
      MT: 2,
      KG: 3,
      PCS: 4,
      BOX: 5,
      MONTH: 6,
      TRANSACTIONS: 7,
    },
  },
  company: {
    status: {
      INITIATED: 0,
      PENDING_VERIFY: 1,
      APPROVED: 2,
      BINKABI_APPROVED: 3,
    },
  },
  subscriptions: {
    LIVE_INVENTORY_MONITORING: 'LIVE_INVENTORY_MONITORING',
    LENDING_MONITORING: 'LENDING_MONITORING',
  },
  pool: {
    statuses: {
      PENDING_ASSETS: 0,
      ASSETS_TRASFERED: 1,
      SELLING: 2,
      PENDING_PAYMENT: 3,
      PAID_BY_BUYER: 4,
      SOLD: 5,
    },
    securityTypes: {
      unsecuredStructuredNotes: 1,
    },
    eventStatuses: {
      ACTIVE: 1,
      FINISHED: 2,
      FAILED: 3,
      PENDING_ALLOCATE: 4,
    },
    saleTypes: {
      PRIVATE: 1,
      MARKETPLACE: 2,
    },
    issuePermission: {
      VIEWER: 1,
      ASSIGNEE: 2,
    },
    eventHistoryTypes: {
      NOTES_ISSUED: 1,
      NOTES_REDEEMED: 2,
    },
    eventSaleTypes: {
      SIMPLE_SUBSCRIPTION: 4,
      DUTCH_AUCTION: 0,
      DIRECT_ALLOCATION: 1,
    },
  },
  document: {
    category: {
      // POOL_SALE: 0,
      // ISSUE_SECURITY: 1,
      // INVESTMENT_SUMMARY: 2,
      // PRIVATE_PLACEMENT_MEMORANDUM: 3,
      LEGAL: 1,
      GENERAL: 2,
    },
    permission: {
      VIEW: 0,
      SIGNER: 1,
      EDIT: 2,
    },
    status: {
      INITIATED: 0,
      ANSWERED: 1,
      DOCUMENTED: 2,
      SIGNED: 3,
    },
  },
  clause: {
    status: {
      INITIATED: 0,
      IMPLEMENTED: 1,
    },
    executionStatus: {
      IDLE: 0,
      PROCESS: 1,
    },
  },
  assetTypes: {
    LENDING: 1,
    INVOICE: 2,
    NOTE_TOKEN: 3,
  },
};

export const assetTypes = {
  LENDING: 1,
  INVOICE: 2,
  NOTE_TOKEN: 3,
};
